var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absoluteItem",attrs:{"id":"chat"}},[_c('p',{staticClass:"common-msg"},[_vm._v("\n    "+_vm._s(_vm.in_room_tip)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }